import { j as e } from "./atoms-v218.js";
import { forwardRef as x } from "react";
import { AddOns as m, AddOnsCategory as j, AddOnsCategoryName as p, AddOnsCategoryList as c, AddOnsItem as A, AddOnsItemPictureSkeletonWrapper as a, AddOnsItemContent as O, AddOnsItemHeader as g, AddOnsItemTitle as f, AddOnsItemSubtitle as u, AddOnsItemDescription as $ } from "./atoms-v278.js";
import { SkeletonRow as t } from "./atoms-v2778.js";
import { Picture as w } from "./atoms-v233.js";
const S = x(
  ({ className: d, id: r, skeletonCategoryCount: i = 2, skeletonItemCount: n = 2, variant: s = "small" }, l) => /* @__PURE__ */ e.jsx(m, { "aria-hidden": "true", className: d, id: r, ref: l, children: Array.from({ length: i }, (k, h) => /* @__PURE__ */ e.jsxs(j, { $variant: s, children: [
    /* @__PURE__ */ e.jsx(p, { $variant: s, children: /* @__PURE__ */ e.jsx(t, { height: s === "small" ? 8 : 10, width: "132px" }) }),
    /* @__PURE__ */ e.jsx(c, { $variant: s, children: Array.from({ length: n }, (I, o) => /* @__PURE__ */ e.jsxs(A, { children: [
      /* @__PURE__ */ e.jsx(a, { $variant: s, children: /* @__PURE__ */ e.jsx(w, { isSkeleton: !0, aspectRatio: "1/1" }) }),
      /* @__PURE__ */ e.jsxs(O, { $variant: s, children: [
        /* @__PURE__ */ e.jsxs(g, { $isSkeleton: !0, children: [
          /* @__PURE__ */ e.jsx(f, { $variant: s, children: /* @__PURE__ */ e.jsx(t, { height: s === "small" ? 8 : 10, width: "132px" }) }),
          /* @__PURE__ */ e.jsx(u, { $variant: s, children: /* @__PURE__ */ e.jsx(t, { height: s === "small" ? 6 : 8, width: "148px" }) })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { children: [
          s === "large" && /* @__PURE__ */ e.jsxs($, { $isSkeleton: !0, children: [
            /* @__PURE__ */ e.jsx(t, { height: 8, width: "354px" }),
            /* @__PURE__ */ e.jsx(t, { height: 8, width: "354px" })
          ] }),
          /* @__PURE__ */ e.jsx(t, { height: s === "small" ? 10 : 12, width: "148px" })
        ] })
      ] })
    ] }, o)) })
  ] }, h)) })
);
S.displayName = "AddOnsSkeleton";
export {
  S as AddOnsSkeleton
};
